// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-AppFooter-AppFooter-module__AppFooter";
var _2 = "webpack-components-shared-AppFooter-AppFooter-module__FooterItem";
var _3 = "webpack-components-shared-AppFooter-AppFooter-module__FooterList";
var _4 = "webpack-components-shared-AppFooter-AppFooter-module__MobileLink";
export { _1 as "AppFooter", _2 as "FooterItem", _3 as "FooterList", _4 as "MobileLink" }
